import { render, staticRenderFns } from "./v-fade.vue?vue&type=template&id=6d9f008c&scoped=true&"
import script from "./v-fade.vue?vue&type=script&lang=js&"
export * from "./v-fade.vue?vue&type=script&lang=js&"
import style0 from "./v-fade.vue?vue&type=style&index=0&id=6d9f008c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9f008c",
  null
  
)

export default component.exports